import { QUEST_DIFFICULTY } from "../../interfaces";

import "../../styles/questedit.css";

const Radio = ({
    checked,
    color,
    onClick,
}: {
    checked: boolean;
    color: string;
    onClick: (x: any) => void;
}) => {
    return (
        <div
            className={`pseudoRadio ${checked ? "active" : ""} diff-${color}`}
            onClick={onClick}
        ></div>
    );
};

export const DifficultySelect = ({
    difficulty,
    setDifficulty,
}: {
    difficulty: number;
    setDifficulty: (x: number) => void;
}) => {
    return (
        <div className="diffWrapper">
            {Object.entries(QUEST_DIFFICULTY).map(([k, v]) => {
                return (
                    <Radio
                        key={k}
                        checked={difficulty === v}
                        color={k}
                        onClick={() => setDifficulty(v)}
                    />
                );
            })}
        </div>
    );
};
